"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.refreshAuthTokenApi = exports.redirectToSignIn = void 0;
exports.storeSelectedAccountId = storeSelectedAccountId;
exports.loadSelectedAccountId = loadSelectedAccountId;
exports.clearAllCookies = clearAllCookies;
var js_cookie_1 = __importDefault(require("js-cookie"));
var types_1 = require("../types");
var env_1 = require("../types/env");
var redirectToSignIn = function () {
    window.location.href = env_1.matchConfig.SIGNIN_PAGE_URL;
};
exports.redirectToSignIn = redirectToSignIn;
function storeSelectedAccountId(accountId) {
    js_cookie_1.default.set(types_1.COOKIE_SELECTED_ACCOUNT, accountId, {
        expires: 30,
        path: '/',
        domain: env_1.matchConfig.ACCOUNT_COOKIE_DOMAIN
    });
}
function loadSelectedAccountId() {
    return js_cookie_1.default.get(types_1.COOKIE_SELECTED_ACCOUNT) || '0';
}
function clearAllCookies() {
    js_cookie_1.default.remove(types_1.COOKIE_ACCESS_TOKEN, {
        path: '/',
        domain: env_1.matchConfig.COOKIE_DOMAIN
    });
    js_cookie_1.default.remove(types_1.COOKIE_SELECTED_ACCOUNT, {
        path: '/',
        domain: env_1.matchConfig.ACCOUNT_COOKIE_DOMAIN
    });
}
var refreshAuthTokenApi = function (_a) {
    var requestHelper = _a.requestHelper, accessToken = _a.accessToken;
    return requestHelper.post(types_1.USER_REFRESH_IMS_API, { accessToken: accessToken }, {
        baseURL: env_1.matchConfig.AUTH0_IMS_API_URL,
        withCredentials: true,
        skipAuthRefresh: true
    });
};
exports.refreshAuthTokenApi = refreshAuthTokenApi;
